var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"result-container"},[_c('h3',[_vm._v("🔗 URL Final Generada")]),_c('div',{staticClass:"url-box"},[_c('input',{attrs:{"type":"text","readonly":"","id":"finalUrl"},domProps:{"value":_vm.url}}),_c('button',{staticClass:"gradient-button",on:{"click":_vm.copiar}},[_vm._v("📋 Copiar")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }